<template>
  <div >
    <NavBar></NavBar>
    <div class="min-h-screen mt-12 xl:mx-32 lg:mx-16">
    <div class="lg:float-left">
                 <div class="h-28 text-center  lg:text-left lg:mb-4 ">
            <p class="text-4xl mt-8 block font-bold"> Get the latest information on the home deals in you area</p>
            <p class="text-2xl mt-2 block font-semibold"> Search for the property deals</p>

            <!-- <img class="rounded-lg mx-auto md:w-56" src="@/assets/img/doc.png" alt="nice condo"> -->

                 </div>

    <div class="pt-2 pb-3 block h-48 bg-white w-full">
  <DropdownMain class="relative z-40 w-full block lg:w-1/3 block h-16 lg:inline-block align-top text-center"></DropdownMain>
  <DropdownSub  class="relative z-30 w-full block lg:w-1/3 block h-12 lg:h-16 lg:inline-block align-top text-center" v-on-clickaway="away"></DropdownSub>
    <button @click="search($event)" style="padding-top:9px;padding-bottom:9px;" class="relative mb-2 z-10 mt-4 lg:mt-0 w-full lg:w-1/6 bg-black text-white rounded-none font-bold px-8  active:bg-gray-900 focus:outline-none">
  Search
</button>
</div>

      </div>
              <img class="hidden  md:block md:mx-auto md:w-1/2 lg:w-1/3  md:block  lg:float-right rounded-lg " src="../assets/img/home.svg" alt="nice condo">

              <!-- <img class="hidden  md:block md:mx-auto md:w-1/2 lg:w-1/3  md:block  lg:float-right rounded-lg " src="../assets/logo.png" alt="nice condo"> -->
  </div>

         <Footer></Footer>
  </div>

</template>

<script>
import {
  mapState, mapGetters, mapMutations, mapActions,
} from 'vuex';
import _ from 'lodash';
import { mixin as clickaway } from 'vue-clickaway';
import DropdownSub from '../components/dropdown/DropdownSub.vue';
import DropdownMain from '../components/dropdown/DropdownMain.vue';
import NavBar from '../components/navigation/Navbar.vue';
import Footer from '../components/footer/Footer.vue';

export default {
  components: {
    DropdownMain, NavBar, Footer, DropdownSub,
  },

  head() {
    return {
      title: {
        inner: 'Home',
      },
      meta: [
        {
          name: 'description',
          content: `${this.appTitle} home page`,
          id: 'desc',
        },
      ],
    };
  },
  data() {
    return {
      isOpen: false,
      loading: false,
      type: [
        { name: 'illness', selected: false },
        { name: 'contraceptive', selected: false },
        { name: 'other', selected: false },
      ],
      selectedType: 'allergies',
      selected: '',
      options: [
        { text: 'illness', value: 'illness' },
        { text: 'contraceptive', value: 'contraceptive' },
        { text: 'other', value: 'other' },
      ],
      restOfCities: [],
      openBox: false,
    };
  },
  mixins: [clickaway],
  computed: {
    ...mapState('search', ['dropdownMainSelected', 'mainCatSelected', 'subCatSelected', 'latestkitlist', 'dropdownIndex', 'mainOptions', 'propertylist', 'MainOptionSelected', 'SelectedOption']),
    ...mapState('app', ['appTitle']),
    ...mapState('card', ['testkitproducts']),
    loadingState() {
      return this.loading;
    },

  },
  methods: {
    ...mapActions('card', ['getTestKitProducts']),
    ...mapActions('search', ['getMainOptions', 'getTestKitProducts', 'getLatest']),
    ...mapGetters('search', ['getDropdown']),
    ...mapMutations('search', ['setDropdownMainCatIndex', 'ResetFirstOption', 'SetMainCatagory', 'SetSubCatagoryDirectly']),
    populateCities(event) {
      console.log(this.$refs.input);
      // `this` inside methods point to the Vue instance
      // `event` is the native DOM event
      event.preventDefault();
      this.openBox = true;
      this.restOfCities = [
        { name: 'Montreal', selected: false },
        { name: 'Vancouver', selected: false },
        { name: 'Toronto', selected: false },
        { name: 'Calgary', selected: false },
      ];
      _.remove(this.restOfCities, this.selected);
    },
    setCity(name, event) {
      // `this` inside methods point to the Vue instance
      // `event` is the native DOM event
      event.preventDefault();
      this.selected = name;
      _.remove(this.restOfCities, { name, selected: false });
      this.restOfCities = [];
      this.openBox = false;
    },
    searchSub() {
      console.log(this.dropdownMainSelected);
    },
    setType(type, event) {
      event.preventDefault();
      this.selectedType = type.name;
    },

    loadSelect(name, index, event) {
      event.preventDefault();
      console.log('loading');
      console.log(name);
      this.setDropdownMainCatIndex({ index });
      this.SetMainCatagory();
      this.ResetFirstOption();
      this.selectedType = name;
    },
    search(event) {
      event.preventDefault();
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 500);
      if (this.mainCatSelected.name === 'Please Select a Category' || this.subCatSelected.name === 'Please Select a Subcatagory') {
        alert('Please Select an option');
      } else {
        this.$router.replace({
          name: 'search',
          params: {
            categoryname: this.mainCatSelected.name, subcatagoryname: this.subCatSelected.name, categoryid: this.dropdownIndex, pagenum: 1,
          },
        });
        this.getTestKitProducts();
      }
    },
    handleBlur() {
      this.restOfCities = this.selected;
    },
  },
  async created() {
    console.log('component mounted');
    await this.getMainOptions();
  },
  async mounted() {
    await this.getLatest();
    await this.getMainOptions();
  },

};
</script>

<style lang="css">
@import '../../public/build/tailwind.css';
</style>
